<template>
  <div class="pigeondoc__text-node" v-html="value.content"></div>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  name: 'TextNodeDisplay',
  props: {
    value: PigeonDocNodeModel,
  },
};
</script>

<style>
.pigeondoc__text-node {
  margin-bottom: 2rem;
}
</style>
